import { Component, input } from "@angular/core";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { TranslocoPipe } from "@jsverse/transloco";
import { DetailsExpansionPanelComponent } from "@components/details-expansion-panel/details-expansion-panel.component";
import { LayerInfoComponent } from "../layer-info/layer-info.component";
import { LayerGroupForm } from "../models/layer-group-form.interface";
import { LayerInfoForm } from "../models/layer-info-form.interface";
import { LayerGroupViewModel } from "../models/layer-group-view-model.interface";

@Component({
  selector: "app-layer-group",
  standalone: true,
  templateUrl: "./layer-group.component.html",
  styleUrls: ["./layer-group.component.scss"],
  imports: [ReactiveFormsModule, MatSlideToggle, TranslocoPipe, DetailsExpansionPanelComponent, LayerInfoComponent]
})
export class LayerGroupComponent {
  groupForm = input.required<FormGroup<LayerGroupForm>>();
  viewModel = input.required<LayerGroupViewModel>();

  get layerInfosArray(): FormArray<FormGroup<LayerInfoForm>> {
    return this.groupForm().controls.layerInfos;
  }

  get filtersArray() {
    return this.groupForm().controls.filters;
  }

  getLayerInfoControlById(id: number): FormGroup<LayerInfoForm> | undefined {
    for (let i = 0; i < this.layerInfosArray.length; i++) {
      const ctrl = this.layerInfosArray.at(i);
      if (ctrl.controls.id.value === id) return ctrl;
    }
    return undefined;
  }
}
